import { useTranslation } from "react-i18next"

type Tab = "home" | "map" | "add" | "favorites" | "profile" | "admin"

interface BottomNavProps {
  activeTab: Tab
  onTabChange: (tab: Tab) => void
  onAddSpot: () => void
}

export default function BottomNav({ activeTab, onTabChange, onAddSpot }: BottomNavProps) {
  const { t } = useTranslation()

  const tabs: { key: Tab; label: string; icon: string }[] = [
    { key: "home", label: t("nav.home"), icon: "/icons/home_icon.png" },
    { key: "map", label: t("nav.map"), icon: "/icons/map_icon.png" },
    { key: "add", label: t("nav.add"), icon: "+" },
    { key: "favorites", label: t("nav.favorites"), icon: "/icons/favorites_icon.png" },
    { key: "profile", label: t("nav.profile"), icon: "/icons/profile_icon.png" },
  ]

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 bg-white/90 dark:bg-slate-900/90 backdrop-blur-md border-t border-gray-200/50 dark:border-slate-700/50 safe-area-pb shadow-[0_-4px_20px_rgba(0,0,0,0.05)]">
      <div className="flex justify-around items-center h-16">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => {
              if (typeof navigator !== "undefined" && navigator.vibrate) {
                navigator.vibrate(15)
              }
              if (tab.key === "add") {
                onAddSpot()
              } else {
                onTabChange(tab.key)
              }
            }}
            className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-all duration-200 active:opacity-70 ${
                activeTab === tab.key && tab.key !== "add"
                ? "opacity-100"
                : "opacity-60"
            } ${tab.key === "add" ? "relative -top-3" : ""}`}
          >
            {tab.key === "add" ? (
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-deepTeal to-forest dark:from-deepTeal-light dark:to-forest-light text-white shadow-lg shadow-deepTeal/30 flex items-center justify-center text-xl transition-transform active:scale-90">
                  {tab.icon}
                </div>
                <span className="text-[10px] font-medium mt-0.5">{tab.label}</span>
              </div>
            ) : (
              <>
                <img
                  src={tab.icon}
                  alt={tab.label}
                  className="w-8 h-8 transition-transform active:scale-75"
                />
                <span className={`text-[10px] font-medium ${
                  activeTab === tab.key
                    ? "text-deepTeal dark:text-steel-light"
                    : "text-gray-500 dark:text-gray-400"
                }`}>{tab.label}</span>
              </>
            )}
          </button>
        ))}
      </div>
    </nav>
  )
}
